import React from "react";
import PropTypes from "prop-types";
import LayoutV2 from "containers/LayoutV2";
import "react-dropdown/style.css";
import { ChoVayCombo } from "constants/choVayConst";
import ReactDropdown from "react-dropdown";
import SearchChoVay from "components/CommonComponent/SearchChoVay";
import { Dropdown } from "react-bootstrap";
import Pagination from "react-js-pagination";
import DongLaiContainer from "containers/Common/QuanLyChoVay/dongLai";
import CustomerDetail from "containers/Common/Customer/customerDetail";
import { PopoversBootrap } from "components/GenericComponent/PopoversBootrap";
import { formatNumber, formatMoney } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
import { catChuoi, catChuoi1 } from "utils/stringExtension";
import { nFormatter } from "utils/currencyFormat";
import choVayConst from "constants/choVayConst";
import { startAndEndOfYear } from "utils/formatDate";
import { formatDayMonth, GetDateHomQua } from "utils/formatDate";
import { getTotalDays } from "utils/choVayUtils";
import { startAndEndOfMonth } from "utils/formatDate";
import { startAndEndOfWeek } from "utils/formatDate";
import GuiEmailContainer from "containers/Common/QuanLyChoVay/GuiEmailContainer";
import TinNhanContainer from "containers/Common/QuanLyChoVay/TinNhanContainer";
import XoaHopDongContainer from "containers/Common/QuanLyChoVay/XoaHopDongContainer";
import DoiTinhTrangNoContainer from "containers/Common/QuanLyChoVay/DoiTinhTrangNoContainer";
import ChiTietHopDongContainer from "containers/Common/QuanLyChoVay/ChiTietHopDongContainer";
import InThuChiContainer from "containers/Common/ThuChi/InThuChiContainer";
import ButtonChuyenForm from "components/CommonComponent/ButtonChuyenForm";
import TatToanContainer from "containers/Common/QuanLyChoVay/TatToanContainer";
import { pushNotification } from "utils/notifications";
import { API_AUTH } from "service/common";
import configs from "../../constants/configs";
import InChoVay from "containers/Common/QuanLyChoVay/inChoVay";
import ThemMoiTraGop from "containers/TraGop/SubContainer/themMoiTraGop";
import { convertDate } from "utils/formatDate";
import DaoHoContainer from "containers/TraGop/SubContainer/daoHoContainer";
import { XuatExcelTraGop } from "../CommonComponent/XuatExcel/TraGop";
import { Cookies } from "react-cookie";
import ChiTietSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietSoTienDaTraContainer";
import ChiTietTongSoTienDaTraContainer from "containers/Common/QuanLyChoVay/ChiTietTongSoTienDaTraContainer";
import GhiChuTraGopContainer from "containers/TraGop/SubContainer/GhiChuTraGopContainer";
import TraGopApi from "service/traGopApi";
import axios from "axios";
import { ModalSuaKyLai } from "components/CommonComponent/DongLai/SuaKyLai/ModalSuaKyLai";
import { ModalInDanhSachDongLai } from "components/CommonComponent/DongLai/InDanhSachDongLai/ModalInDanhSachDongLai";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import cauHinh from "utils/cauHinh";
import CauHinhApi from "../../service/cauHinhApi";
import userApi from "service/userApi";
import { ModelQRThanhToanHD } from "components/TichHopBank/ModelQRThanhToanHD";
import DanhDachIcloudApi from "../../service/QuanTriHeThong/DanhDachIcloudApi";
import Autocomplete from "react-autocomplete";
import NguonKhachHangApi from "../../service/nguonKhachHangApi";
import ThayDoiLaiSuatContainer from "containers/Common/QuanLyChoVay/ThayDoiLaiSuatContainer";
import ThayDoiKyLaiTraGopContainer from "containers/Common/QuanLyChoVay/ThayDoiKyLaiTraGopContainer";
import { ModelThietLapHienThi } from "./ModelThietLapHienThi";
import ThietLapHienThiApi from "../../service/QuanTriHeThong/ThietLapHienThiApi";
import { formatCurrency } from "utils/currencyFormat";
import ThayDoiKyLaiTraGop from "components/CommonComponent/ThayDoiKyLaiTraGop";

class TraGop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showTKNangCao: false,
      showChiTietKhachHang: false,
      showChiTietHopDong: false,
      showTinNhanSMS: false,
      showGuiEmail: false,
      showXoa: false,
      showThayDoiLaiSuat: false,
      showDoiTinhTrangNo: false,
      showThemMoiTraGop: false,
      showDaoHo: false,
      showGhiChu: false,
      dataSearch: {
        dateFrom: "01/01/2001",
        dateTo: "01/01/4000",
        code: "",
        customerName: "",
        address: "",
        noteTaiSan: "",
        status: "5",
        debt: "-1",
        userName: "",
        pageIndex: 1,
        pageSize: 20,
        ThoiGian: "",
        taiSan: 0,
        manhanvien: "",
        dongtungay: "01/01/2001",
        dongdenngay: "01/01/4000",
        taiKhoanIcloudId: 0,
        nguonKhachHangId: "0",
      },
      choVay: {},
      showDongLai: false,
      showXuatExcel3: false,
      showChiTietSoTienDaTra: false,
      showChiTietTongSoTienDaTra: false,
      isShowGhiChuTraGop: false,
      isShowSuaKyLai: false,
      dataSuaKyLai: {},
      isShowInDanhSachDongLai: false,
      dataInDanhSachDongLai: {},
      dataTotalDongLai: {},
      TT_Amercement: 0,
      TT_OtheFeeHangKy: 0,
      TT_OtherFee: 0,
      TT_PhiHoaHongTraGop: 0,
      TT_PhiKho: 0,
      TT_PhiPhatDongLai: 0,
      TT_PhiPhatTatToan: 0,
      TT_ValueGoc: 0,
      TT_ValueLai: 0,
      TotalPaid: 0,
      TotalPaidToDateNow: 0,
      TotalMoney: 0,
      isLoadingTongTien: false,
      isQRThanhToan: false,
      isShowModalQRThanhToanHD: false,
      itemDataQR: {},
      isCauHinhT77: false,
      isCauHinhKhachHangBinhAn: false,
      isCauHinhKhachHangVSNY: false,
      isShowModalThietLapHienThi: false,
      showThayDoiKyLai: false,
      objThietLapHienThiDanhSach: {},
      listTinhTrangNo: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
      listNhanVien: [
        {
          value: "-1",
          label: "Tất cả",
        },
      ],
      listTaiKhoanIcloud: [],
      isCauHinhTaiKhoanIcloud: false,
      TaiKhoanIcloudId: 0,
      sSearchTaiKhoanIcloud: "",
      lstNguonKhachHangInDB: [],
      lstNguonKhachHangSearch: [],
      lstNguonKhachHangShowSelect: [],
      sNguonKhachHangDanhSach: "",
      configIsThongTinTong: 0,
    };
  }
  componentDidMount() {
    document.title = "Trả góp | Phần mềm quản lý TotalMoneyđồ Morman";
    let { dataSearch } = this.state;
    let { getPhanQuyenTraGop, getComboUser, getConfig, getConfigSysTMTG } =
      this.props;
    getPhanQuyenTraGop();
    getComboUser();
    getConfig();
    getConfigSysTMTG();
    this.getThietLapHienThi();
    this.loadTotalTraGop(dataSearch);
    TraGopApi.getConfigSys().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const isShowNote = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsShowGhiChu.toUpperCase(),
          );
          if (isShowNote != null) {
            if (isShowNote.valueConfig === "1") {
              this.setState({ isShowGhiChuTraGop: true });
            }
          }
          const configThongTinTong = response.data.find(
            (e) => e.keyConfig === "IsThongTinTong",
          );

          if (configThongTinTong) {
            this.setState({
              configIsThongTinTong: configThongTinTong.valueConfig,
            });
          }
        }
      }
    });
    NguonKhachHangApi.combo().then((response) => {
      this.setState({
        lstNguonKhachHangInDB: response.data,
        lstNguonKhachHangSearch: response.data,
        lstNguonKhachHangShowSelect: response.data,
      });
    });
    // lay danh sach nhan vien
    userApi.combo().then((response) => {
      if (response.status === 200) {
        const users = response.data.map((item) => ({
          value: item.value == "0" ? "" : item.value,
          label: item.label,
        }));
        this.setState({ listNhanVien: users });
      }
    });

    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase(),
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              this.setState({ isQRThanhToan: true });
            }
          }
          const configCauHinhT77 = response.data.find(
            (e) =>
              e.keyConfig &&
              e.keyConfig.toUpperCase() ===
                cauHinh.sKey.IsCauHinhT77.toUpperCase(),
          );
          const isCauHinhT77 =
            configCauHinhT77 != null && configCauHinhT77.valueConfig === "1";
          this.setState({
            isCauHinhT77,
          });
          const isCauHinhTaiKHoanIcloud = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsTaiKhoanIcloud.toUpperCase(),
          );
          if (isCauHinhTaiKHoanIcloud != null) {
            if (isCauHinhTaiKHoanIcloud.valueConfig === "1") {
              this.setState({ isCauHinhTaiKhoanIcloud: true });
            }
          }
        }
      }
    });

    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: item.Code,
          label: item.Name,
        }));
        const dataComboTinhTrangNew = [
          { value: "-1", label: "Tất cả" },
          ...dataComboTinhTrang,
        ];
        this.setState(
          { listTinhTrangNo: dataComboTinhTrangNew },
          this.getConfigKey,
        );
      }
    });
  }
  getThietLapHienThi() {
    ThietLapHienThiApi.thietLapDanhSachTraGop().then((response) => {
      this.setState({ objThietLapHienThiDanhSach: response.data });
    });
  }
  onSelectIcloud = (value, taikhoanICloud) => {
    this.setState({
      sSearchTaiKhoanIcloud: value,
      TaiKhoanIcloudId: taikhoanICloud.Id,
    });
    let { dataSearch } = this.state;
    dataSearch.taiKhoanIcloudId = taikhoanICloud.Id;
    this.setState({ dataSearch });
  };

  onChangeTextIcloud = (event, value) => {
    this.setState({
      sSearchTaiKhoanIcloud: value,
      TaiKhoanIcloudId: 0,
    });
    let { dataSearch } = this.state;
    dataSearch.taiKhoanIcloudId = 0;
    this.setState({ dataSearch });
    this.onSearchTaiKhoanIcloud(event.target.value);
  };
  onSearchTaiKhoanIcloud = (data) => {
    DanhDachIcloudApi.list({
      SoDienThoai: "",
      TenTaiKhoan: data,
      SoHDLienKet: -1,
      iHanChe: -1,
      iLock: 0,
      iPageSize: 20,
      iPageIndex: 1,
    }).then((response) => {
      if (response.status == "200") {
        this.setState({ listTaiKhoanIcloud: response.data.List });
      }
    });
  };

  onSelectNguonKhachHang = (value, nguonkhachhang) => {
    this.setState({
      sSearchNguonKhachHang: value,
    });
    let { dataSearch } = this.state;
    dataSearch.nguonKhachHangId = nguonkhachhang.NguonKhId;
    this.setState({ dataSearch });
  };

  onChangeNguonKhachHang = (event, value) => {
    this.setState({
      sSearchNguonKhachHang: value,
    });
    let { dataSearch, lstNguonKhachHangInDB } = this.state;
    dataSearch.nguonKhachHangId = 0;
    this.setState({ dataSearch });
    let lstNguon = lstNguonKhachHangInDB.filter(function (item) {
      return item.label.indexOf(value) > -1;
    });

    this.setState({
      sNguonKhachHangDanhSach: "",
      lstNguonKhachHangSearch: lstNguon,
    });
  };

  getNhanVienLabel = (value) => {
    const { listNhanVien } = this.state;
    if (!Array.isArray(listNhanVien) || value === "") return value;
    const found = listNhanVien.find((nv) => nv.value === value);
    return found ? found.label : value;
  };

  setModalTaiSan = (taiSanId) => () => {
    let { showModalTaiSan } = this.state;
    this.setState({ taiSanId, showModalTaiSan: !showModalTaiSan });
  };

  componentDidUpdate() {
    let { phanquyen, inthuchi } = this.props;
    let { showTatToan, dataSearch } = this.state;
    let { PhanQuyenTraGop } = phanquyen;
    let { inThuChiShow } = inthuchi;
    let { laiho_danhsachlaiho } = PhanQuyenTraGop;
    if (laiho_danhsachlaiho !== undefined && !laiho_danhsachlaiho) {
      window.location.href = configs.errorLink;
    }
    if (showTatToan && inThuChiShow) {
      dataSearch.status = "2";
      this.setState({ showTatToan: false });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  }
  getConfigKey() {
    CauHinhApi.getConfigSys1().then((response) => {
      if (response.status === 200) {
        if (response.data.length > 0) {
          const configIsQRThanhToan = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsQRThanhToan.toUpperCase(),
          );
          if (configIsQRThanhToan != null) {
            if (configIsQRThanhToan.valueConfig === "1") {
              this.setState({ isQRThanhToan: true });
            }
          }
          const isShowNote = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsShowGhiChu.toUpperCase(),
          );
          if (isShowNote != null) {
            if (isShowNote.valueConfig === "1") {
              this.setState({ isShowGhiChuTraGop: true });
            }
          }
          let { dataSearch } = this.state;
          const configNangCapKhachHangBinhAn = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHBinhAn.toUpperCase(),
          );
          if (configNangCapKhachHangBinhAn != null) {
            if (configNangCapKhachHangBinhAn.valueConfig === "1") {
              dataSearch.debt = "999";
              this.setState({ isCauHinhKhachHangBinhAn: true });
              this.setState({ dataSearch });
            }
          }
          const configNangCapKhachHangVSNY = response.data.find(
            (e) =>
              e.keyConfig.toUpperCase() ===
              cauHinh.sKey.IsNangCapKHVSNY.toUpperCase(),
          );
          if (configNangCapKhachHangVSNY != null) {
            if (configNangCapKhachHangVSNY.valueConfig === "1") {
              this.setState({ isCauHinhKhachHangVSNY: true });
            }
          }

          this.loadTraGop(dataSearch);
        }
      }
    });
  }
  loadTraGop(dataSearch) {
    let { getListTraGop } = this.props;
    getListTraGop(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  loadTraGop2(dataSearch) {
    let { getListTraGop } = this.props;
    getListTraGop(dataSearch);
    // document.body.scrollTop = 0; // For Safari
    // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }

  loadTotalTraGop(dataSearch) {
    this.setState({ isLoadingTongTien: true });
    TraGopApi.toTalTraGop(
      dataSearch.dateFrom,
      dataSearch.dateTo,
      dataSearch.code,
      dataSearch.customerName,
      dataSearch.address,
      dataSearch.noteTaiSan,
      dataSearch.status,
      dataSearch.debt,
      dataSearch.userName,
      dataSearch.taiSan,
      dataSearch.dongtungay,
      dataSearch.dongdenngay,
      dataSearch.manhanvien,
      dataSearch.pageIndex,
      dataSearch.pageSize,
      dataSearch.taiKhoanIcloudId,
      dataSearch.nguonKhachHangId,
    ).then((response) => {
      if (response.status === 200) {
        this.setState({ isLoadingTongTien: false });
        this.setState({
          TT_Amercement: response.data.TT_Amercement,
          TT_OtheFeeHangKy: response.data.TT_OtheFeeHangKy,
          TT_OtherFee: response.data.TT_OtherFee,
          TT_PhiHoaHongTraGop: response.data.TT_PhiHoaHongTraGop,
          TT_PhiKho: response.data.TT_PhiKho,
          TT_PhiPhatDongLai: response.data.TT_PhiPhatDongLai,
          TT_PhiPhatTatToan: response.data.TT_PhiPhatTatToan,
          TT_ValueGoc: response.data.TT_ValueGoc,
          TT_ValueLai: response.data.TT_ValueLai,
          TotalPaid: response.data.TotalPaid,
          TotalPaidToDateNow: response.data.TotalPaidToDateNow,
          TotalMoney: response.data.TotalMoney,
        });
      } else {
        this.setState({ isLoadingTongTien: false });
      }
      console.log(response, "check tổng");
    });
  }
  setTKNangCaoModalShow = (dataSearch) => {
    this.setState({ showTKNangCao: !this.state.showTKNangCao });
    if (dataSearch && this.state.showTKNangCao) {
      dataSearch.customerName = dataSearch.customerName.trim();
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };
  setModalChiTietKhachHangShow = (choVay) => () => {
    let { showChiTietKhachHang } = this.state;
    if (choVay)
      this.setState({ showChiTietKhachHang: !showChiTietKhachHang, choVay });
    else this.setState({ showChiTietKhachHang: !showChiTietKhachHang });
    if (showChiTietKhachHang) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };
  setModalChiTietHopDongShow = (choVay) => () => {
    let { showChiTietHopDong } = this.state;
    if (choVay)
      this.setState({ showChiTietHopDong: !showChiTietHopDong, choVay });
    else this.setState({ showChiTietHopDong: !showChiTietHopDong });
    if (showChiTietHopDong) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };

  setModalTinNhanSMSShow = (choVay) => () => {
    let { showTinNhanSMS } = this.state;
    if (choVay) this.setState({ showTinNhanSMS: !showTinNhanSMS, choVay });
    else this.setState({ showTinNhanSMS: !showTinNhanSMS });
    if (showTinNhanSMS) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };

  setModalGuiEmailShow = (choVay) => () => {
    let { showGuiEmail } = this.state;
    if (choVay) this.setState({ showGuiEmail: !showGuiEmail, choVay });
    else this.setState({ showGuiEmail: !showGuiEmail });
    if (showGuiEmail) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };

  setModalXoaShow = (choVay) => () => {
    let { showXoa } = this.state;
    if (choVay) this.setState({ showXoa: !showXoa, choVay });
    else this.setState({ showXoa: !showXoa });
    if (showXoa) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };

  setModalDoiTinhTrangNoShow = (choVay) => () => {
    let { showDoiTinhTrangNo } = this.state;
    if (choVay)
      this.setState({ showDoiTinhTrangNo: !showDoiTinhTrangNo, choVay });
    else this.setState({ showDoiTinhTrangNo: !showDoiTinhTrangNo });
    if (showDoiTinhTrangNo) {
      let { dataSearch } = this.state;
      //dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };
  setDongLaiModalShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    if (data)
      this.setState({
        showDongLai: !this.state.showDongLai,
        choVay: data,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showThayDoiLaiSuat: false,
        showVayThem: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showDongLai: !this.state.showDongLai });
    if (this.state.showDongLai) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop2(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };
  setModalTatToanShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showTatToan } = this.state;
    if (data)
      this.setState({
        showTatToan: !showTatToan,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showThayDoiLaiSuat: false,
        showVayThem: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showTatToan: !showTatToan });
    if (showTatToan) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };

  setModalThayDoiLaiSuatShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showThayDoiLaiSuat } = this.state;
    if (data)
      this.setState({
        showThayDoiLaiSuat: !showThayDoiLaiSuat,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showTatToan: false,
        showThayDoiKyLai: false,
      });
    else this.setState({ showThayDoiLaiSuat: !showThayDoiLaiSuat });
    console.log("showThayDoiLaiSuat", showThayDoiLaiSuat);
    if (showThayDoiLaiSuat) {
      let { dataSearch } = this.state;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };

  setModalTraGopShow = (chovay) => () => {
    let { showFormTraGop, themmoitragop } = this.props;
    let choVayEdit = null;
    if (chovay) {
      choVayEdit = { ...chovay };
      console.log("data list chovay TypeDuNo", chovay.TypeDuNo, chovay);
      if (choVayEdit.kyLai && parseFloat(choVayEdit.kyLai) > 0)
        choVayEdit.CountTypePaid = choVayEdit.kyLai;
      choVayEdit.NgayVay = convertDate(chovay.NgayVay);
      choVayEdit.NgayThanhToan = convertDate(chovay.DatePaid);
    }
    this.setState({
      choVayEdit,
    });
    let { isShowFormTraGop } = themmoitragop;
    this.props.themmoitragop.postTraGopReturn = false;
    this.props.themmoitragop.postTraGopLoading = true;
    this.props.themmoitragop.TaiSanTraGop.AnhTaiSan = "";
    if (isShowFormTraGop) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
    showFormTraGop(choVayEdit);
  };
  setModalThayDoiKyLaiShow = (data) => () => {
    this.setState({
      choVay: {},
    });
    let { showThayDoiKyLai } = this.state;
    if (data) {
      this.setState({
        showThayDoiKyLai: !showThayDoiKyLai,
        choVay: data,
        showDongLai: false,
        showTKNangCao: false,
        showGiaHanKy: false,
        showTraBotGoc: false,
        showTatToan: false,
        showThayDoiLaiSuat: false,
      });
    } else this.setState({ showThayDoiKyLai: !showThayDoiKyLai });
    if (showThayDoiKyLai) {
      let { dataSearch } = this.state;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
    }
  };
  setIsTraGopReturn = () => {
    this.props.themmoitragop.postTraGopReturn = false;
  };
  setModalDaoHoShow = (data) => () => {
    let { showFormDaoHo } = this.props;
    showFormDaoHo(data);
  };
  setLoadingToTalDaoHo = () => () => {
    let { dataSearch } = this.state;
    this.loadTotalTraGop(dataSearch);
  };
  setInChoVayModalShow = () => () => {
    let { showInChoVay, choVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInChoVayModalShowTM = (choVay) => () => {
    let { showInChoVay } = this.state;
    if (choVay && !choVay.ChoVayId) {
      pushNotification("Hãy chọn hợp đồng", "warning", "TOP_CENTER", 1000);
      return;
    }
    this.setState({ choVay });
    this.setState({ showInChoVay: !showInChoVay });
  };
  setInThuChiModalShow = (thuChiId) => () => {
    let { showInPhieuThuChi } = this.props;
    showInPhieuThuChi(thuChiId);
  };

  setSuaKyLaiModalShow = (data, obj) => () => {
    this.setState({
      isShowSuaKyLai: !this.state.isShowSuaKyLai,
      dataSuaKyLai: data,
      dataTotalDongLai: obj,
    });
  };

  setInDanhSachDongLaiShow = (data) => () => {
    this.setState({
      isShowInDanhSachDongLai: !this.state.isShowInDanhSachDongLai,
      dataInDanhSachDongLai: data,
    });
  };

  setInThuChiModalShow = (thuChiId) => () => {
    let { showInPhieuThuChi } = this.props;
    showInPhieuThuChi(thuChiId);
  };
  xuatExcel = () => () => {
    let { dataSearch } = this.state;
    let {
      dateFrom,
      dateTo,
      code,
      customerName,
      address,
      noteTaiSan,
      status,
      debt,
      userName,
      dongtungay,
      dongdenngay,
      manhanvien,
    } = dataSearch;
    const cookies = new Cookies();
    let link = configs.endPoint;
    var apilink = cookies.get("apilink");
    if (typeof apilink != "undefined" && apilink.length > 0) {
      link = apilink;
    }
    var token = cookies.get("userInfo");
    if (typeof token != "undefined" && token.length > 6) {
      token = token.substring(6).replace(/"/g, "");
    }
    link =
      link +
      `quanlychovay/tra-gop-xuat-excel?dateFrom=${dateFrom}&dateTo=${dateTo}&code=${code}&customerName=${customerName}&address=${address}&noteTaiSan=${noteTaiSan}&status=${status}&debt=${debt}&userName=${userName}&dongtungay=${dongtungay}&dongdenngay=${dongdenngay}`;
    axios
      .get(link, {
        method: "GET",
        headers: {
          Authorization: token,
        },
        responseType: "blob", // important
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
      });
  };
  selectRow = (item) => () => {
    this.setState({ choVay: item });
  };

  xuatExcel3 = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = true;
    this.setState({ showXuatExcel3 });
  };

  setModalSaoChepShow = (chovay) => () => {
    let choVayEdit = { ...chovay, IsCopy: true };
    if (chovay) {
      choVayEdit.NgayVay = new Date();
      choVayEdit.NgayTra = convertDate(chovay.NgayTra);
      choVayEdit.NgayThanhToan = convertDate(chovay.DatePaid);
      choVayEdit.TongNgayVay = getTotalDays(
        choVayEdit.NgayVay,
        choVayEdit.NgayTra,
      );
    }
    this.setState({
      choVayEdit,
    });
    let { showFormTraGop, themmoitragop } = this.props;
    let { isShowFormTraGop } = themmoitragop;
    if (isShowFormTraGop) {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
    showFormTraGop(choVayEdit);
  };

  hideXuatExcel = () => () => {
    let { showXuatExcel3 } = this.state;
    showXuatExcel3 = false;
    this.setState({ showXuatExcel3 });
  };

  setModalChiTietTienDaTraShow = (choVay) => () => {
    let { showChiTietSoTienDaTra } = this.state;
    if (choVay)
      this.setState({
        showChiTietSoTienDaTra: !showChiTietSoTienDaTra,
        choVay,
      });
    else this.setState({ showChiTietSoTienDaTra: !showChiTietSoTienDaTra });
  };

  setModalChiTietTongTienDaTraShow = () => () => {
    let { showChiTietTongSoTienDaTra } = this.state;
    this.setState({ showChiTietTongSoTienDaTra: !showChiTietTongSoTienDaTra });
  };
  renderTableRows() {
    let {
      tragop,
      phanquyen,
      showXoaHopDong,
      showModalGuiEmail,
      showModalGuiTinNhan,
    } = this.props;
    let { PhanQuyenTraGop } = phanquyen;
    let {
      laiho_doitinhtranghopdong,
      laiho_thanhtoan,
      laiho_sualaiho,
      laiho_guiemail,
      laiho_nhantin,
      laiho_tattoan,
      laiho_thongtinchitiethopdong,
      laiho_thongtinchitietkhachhang,
      laiho_xoalaiho,
      laiho_daoho,
      tragop_suatientattoan,
      SuDungCongTacVienNhanVien,
      SuDungMaNhanVien,
      SuDungTatToanSom,
      tragop_thaydoilaisuat,
      tragop_thaydoikylai,
    } = PhanQuyenTraGop;
    let {
      choVay,
      isQRThanhToan,
      isCauHinhKhachHangVSNY,
      isCauHinhTaiKhoanIcloud,
      sNguonKhachHangDanhSach,
      lstNguonKhachHangInDB,
      lstNguonKhachHangSearch,
      objThietLapHienThiDanhSach,
    } = this.state;
    if (
      isCauHinhTaiKhoanIcloud == true &&
      sNguonKhachHangDanhSach != tragop.objList.sNguonKhachHang
    ) {
      let lstNguon = lstNguonKhachHangSearch.filter(function (item) {
        return (
          ("_" + tragop.objList.sNguonKhachHang + "_0_").indexOf(
            "_" + item.NguonKhId + "_",
          ) > -1
        );
      });
      var iCount = lstNguon.length - 1;
      let lstNguon1 = lstNguon.map((item, index) => {
        if (item.NguonKhId == 0) {
          item.label = item.TenNguonKh + " (" + iCount + ")";
        }
        return item;
      });

      let { dataSearch } = this.state;
      if (lstNguon1.length == 1) {
        dataSearch.nguonKhachHangId = 0;
      }
      this.setState({
        sNguonKhachHangDanhSach: tragop.objList.sNguonKhachHang,
        lstNguonKhachHangShowSelect: lstNguon1,
        dataSearch: dataSearch,
      });
    }
    return tragop.objList.List.map((item, index) => (
      <div
        className={"custom-table-row " + (item === choVay && "active")}
        key={"item" + index}
        onClick={this.selectRow(item)}
      >
        {item.DebtLevel === 50 && (
          <span className="line-job-color job-color-picker-1"></span>
        )}
        {item.DebtLevel === 20 && (
          <span className="line-job-color job-color-picker-2"></span>
        )}
        {item.DebtLevel === 30 && (
          <span className="line-job-color job-color-picker-3"></span>
        )}
        {item.DebtLevel === 40 && (
          <span className="line-job-color job-color-picker-4"></span>
        )}
        {objThietLapHienThiDanhSach.IsAnSTT != true && (
          <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
            <span className="mobile-column-name color7-bold">STT</span>
            <div className="center-wrapper">
              <p className="text-center color7">{item.IndexId}</p>
            </div>
          </div>
        )}
        {isCauHinhKhachHangVSNY == false && (
          <>
            {objThietLapHienThiDanhSach.IsAnMaHD != true && (
              <div className="custom-table-cell flex-basis-9 flex-basis-15-6-sm">
                <span className="mobile-column-name color7-bold">
                  Mã hợp đồng
                </span>
                <div className="center-wrapper">
                  <span className="profile_name word-break">
                    {laiho_thongtinchitiethopdong ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietHopDongShow(item)}
                      >
                        {item.Code}
                      </a>
                    ) : (
                      item.Code
                    )}
                    <span className="font-lai color7">
                      <br />
                      {getDate(item.NgayVay)}
                      <br />
                      {getDate(item.NgayTra)}
                    </span>
                  </span>
                </div>
              </div>
            )}

            {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
              (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                <div className="custom-table-cell flex-basis-6 flex-basis-6-sm">
                  <span className="mobile-column-name color7-bold">
                    {SuDungCongTacVienNhanVien ? "Mã nhân viên" : "Nhân viên"}
                  </span>
                  <div className="center-wrapper">
                    <p
                      className="text-left text-truncate"
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        margin: 0,
                      }}
                      title={this.getNhanVienLabel(item.MaNhanVien)}
                    >
                      {this.getNhanVienLabel(item.MaNhanVien)}
                    </p>
                  </div>
                </div>
              )}
            {objThietLapHienThiDanhSach.IsAnTenKH != true && (
              <div
                className={`custom-table-cell ${
                  SuDungCongTacVienNhanVien || SuDungMaNhanVien
                    ? "flex-basis-12 flex-basis-11-8-sm"
                    : "flex-basis-11 flex-basis-11-8-sm"
                }`}
              >
                <span className="mobile-column-name color7-bold">
                  Tên khách hàng
                </span>
                <div className="center-wrapper">
                  {laiho_thongtinchitietkhachhang ? (
                    <a
                      id=""
                      href={() => false}
                      className="blue btn-link"
                      onClick={this.setModalChiTietKhachHangShow(item)}
                    >
                      {item.CustomerName}
                    </a>
                  ) : (
                    item.CustomerName
                  )}

                  <br />
                  {item.phoneCus && (
                    <span title={item.phoneCus} className="font-lai color7">
                      {" "}
                      {catChuoi(item.phoneCus, 10)}
                    </span>
                  )}
                </div>
              </div>
            )}
          </>
        )}
        {isCauHinhKhachHangVSNY == true && (
          <>
            {objThietLapHienThiDanhSach.IsAnTenKH != true && (
              <div
                className={`custom-table-cell ${
                  SuDungCongTacVienNhanVien || SuDungMaNhanVien
                    ? "flex-basis-12 flex-basis-11-8-sm"
                    : "flex-basis-11 flex-basis-11-8-sm"
                }`}
              >
                <span className="mobile-column-name color7-bold">
                  Tên khách hàng
                </span>
                <div className="center-wrapper">
                  {laiho_thongtinchitietkhachhang ? (
                    <a
                      id=""
                      href={() => false}
                      className="blue btn-link"
                      onClick={this.setModalChiTietKhachHangShow(item)}
                    >
                      <span title={item.CustomerName}>
                        {" "}
                        {item.CustomerName}
                      </span>
                    </a>
                  ) : (
                    <span title={item.CustomerName}> {item.CustomerName}</span>
                  )}

                  <br />
                  {item.phoneCus && (
                    <span title={item.phoneCus} className="font-lai color7">
                      {" "}
                      {catChuoi(item.phoneCus, 10)}
                    </span>
                  )}
                </div>
              </div>
            )}
            {objThietLapHienThiDanhSach.IsAnMaHD != true && (
              <div className="custom-table-cell flex-basis-9 flex-basis-15-6-sm">
                <span className="mobile-column-name color7-bold">
                  Mã hợp đồng
                </span>
                <div className="center-wrapper">
                  <span className="profile_name  word-break">
                    {laiho_thongtinchitiethopdong ? (
                      <a
                        id=""
                        href={() => false}
                        className="blue btn-link"
                        onClick={this.setModalChiTietHopDongShow(item)}
                      >
                        {item.Code}
                      </a>
                    ) : (
                      item.Code
                    )}
                  </span>
                  <span className="font-lai color7">
                    <br />
                    {getDate(item.NgayVay)}
                    <br />
                    {getDate(item.NgayTra)}
                  </span>
                </div>
              </div>
            )}

            {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
              (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                <div className="custom-table-cell flex-basis-6 flex-basis-6-sm">
                  <span className="mobile-column-name color7-bold">
                    {SuDungCongTacVienNhanVien ? "Mã nhân viên" : "Nhân viên"}
                  </span>
                  <div className="center-wrapper">
                    <p
                      className="text-left text-truncate"
                      style={{
                        maxWidth: "80px",
                        overflow: "hidden",
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        margin: 0,
                      }}
                      title={this.getNhanVienLabel(item.MaNhanVien)}
                    >
                      {this.getNhanVienLabel(item.MaNhanVien)}
                    </p>
                  </div>
                </div>
              )}
          </>
        )}
        {objThietLapHienThiDanhSach.IsAnTSTheChap != true &&
          isCauHinhTaiKhoanIcloud == false && (
            <div className="custom-table-cell flex-basis-8 flex-basis-7-sm">
              <span className="mobile-column-name color7-bold">
                TS thế chấp
              </span>
              <div className="center-wrapper">
                <p className="text-center color7" title={item.TaiSan}>
                  {catChuoi(item.TaiSan, 10)}
                </p>
              </div>
            </div>
          )}

        {isCauHinhTaiKhoanIcloud == true && (
          <div className="custom-table-cell flex-basis-8 flex-basis-6-sm">
            <span className="mobile-column-name color7-bold">
              Nguồn khách hàng
            </span>
            <div className="center-wrapper">
              <p className="text-center color7">{item.NguonKhachHang}</p>
            </div>
          </div>
        )}
        {isCauHinhTaiKhoanIcloud == true && (
          <div className="custom-table-cell flex-basis-16 flex-basis-12-sm">
            <span className="mobile-column-name color7-bold">Icloud</span>
            <div className="center-wrapper">
              <p className="text-center word-break" title={item.TaiKhoanIcloud}>
                {item.TaiKhoanIcloud}
              </p>
            </div>
          </div>
        )}

        {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
          this.state.isCauHinhKhachHangBinhAn == false && (
            <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
              <span className="mobile-column-name color7-bold">
                Số tiền vay
              </span>
              <div className="center-wrapper">
                <p className="text-right color7">
                  <span
                    className="fontnew-500 color-do-bold"
                    title={formatNumber(item.SoTienVayConLai)}
                  >
                    {formatMoney(item.SoTienVayConLai)}
                  </span>{" "}
                  <br />{" "}
                  <span className="font-lai  color7">
                    {" "}
                    (
                    {item.StatusPaidHo === 1 &&
                      "Lãi thiếu: " +
                        nFormatter(
                          Math.ceil(item.ValueLai * item.CountTypePaid),
                        )}
                    {item.StatusPaidHo === 2 &&
                      "Lãi đủ: " +
                        ((item?.Phantram ?? 0) > 0
                          ? nFormatter(item.Phantram) + "%"
                          : nFormatter(item.ValueLai * item.BocTrongVong))}
                    {item.StatusPaidHo === 3 &&
                      "Chi phí vay: " + nFormatter(item.ChiPhiVay) + "%"}
                    )
                  </span>
                </p>
              </div>
            </div>
          )}
        {this.state.isCauHinhKhachHangBinhAn == true && (
          <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Tiền đưa khách
            </span>
            <div className="center-wrapper">
              <p className="text-right">
                <span
                  className="fontnew-500"
                  title={formatNumber(item.SoTienVayConLai)}
                >
                  {formatMoney(item.SoTienVayConLai)}
                </span>{" "}
                <br />{" "}
                <span className="font-lai">
                  {" "}
                  (
                  {item.StatusPaidHo === 1 &&
                    "Lãi thiếu: " +
                      nFormatter(Math.ceil(item.ValueLai * item.CountTypePaid))}
                  {item.StatusPaidHo === 2 &&
                    "Lãi đủ: " + nFormatter(item.ValueLai * item.BocTrongVong)}
                  {item.StatusPaidHo === 3 &&
                    "Chi phí vay: " + nFormatter(item.ChiPhiVay) + "%"}
                  )
                </span>
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnSoTienDaTra != true && (
          <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Số tiền đã trả
            </span>
            <div className="center-wrapper">
              <p className="text-right color7   color-xanh-bold">
                {" "}
                <span
                  title={formatNumber(
                    item.TC_ValueGoc +
                      item.TC_ValueLai +
                      item.TC_PhiKho +
                      item.TC_OtheFeeHangKy +
                      item.TC_Amercement +
                      item.TC_OtherFee +
                      item.TC_PhiPhatDongLai +
                      item.TC_PhiHoaHongTraGop +
                      item.TC_PhiPhatTatToan,
                  )}
                >
                  {" "}
                  <a
                    id=""
                    href={() => false}
                    className="blue btn-link"
                    onClick={this.setModalChiTietTienDaTraShow(item)}
                  >
                    {formatMoney(
                      item.TC_ValueGoc +
                        item.TC_ValueLai +
                        item.TC_PhiKho +
                        item.TC_OtheFeeHangKy +
                        item.TC_Amercement +
                        item.TC_OtherFee +
                        item.TC_PhiPhatDongLai +
                        item.TC_PhiHoaHongTraGop +
                        item.TC_PhiPhatTatToan,
                    )}
                    {/* {formatNumber(item.Paided)} */}
                  </a>
                </span>
              </p>

              {item.SoLanDaDong > 0 && (
                <p className="text-right font-lai">({item.SoLanDaDong} kỳ)</p>
              )}
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnTienVayConLai != true && (
          <div className="custom-table-cell flex-basis-11 flex-basis-13-sm">
            <span className="mobile-column-name color7-bold">
              Còn phải đóng
            </span>
            <div className="center-wrapper">
              <p className="text-right">
                <span
                  className="color7-bold"
                  title={formatNumber(item.ValuePaid - item.Paided)}
                >
                  {formatMoney(item.ValuePaid - item.Paided)}
                </span>
                <br />
                {item.SoLanPhaiDong > 0 && (
                  <p className="font-lai">({item.SoLanPhaiDong} kỳ)</p>
                )}
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnTrangThai != true && (
          <div className="custom-table-cell flex-basis-6 flex-basis-6-sm">
            <span className="mobile-column-name color7-bold">Trạng thái</span>
            <div className="center-wrapper">
              <p className="text-center">
                <span
                  className={
                    item.Status === 4
                      ? "canh-bao-red-v2"
                      : item.Status === 3
                        ? "canh-bao-no"
                        : item.Status === 2
                          ? "dong"
                          : "dang-vay"
                  }
                >
                  {choVayConst.StatusHoText[item.Status]}
                </span>
              </p>
            </div>
          </div>
        )}
        {this.state.isShowGhiChuTraGop === true && (
          <div className="custom-table-cell flex-basis-10  flex-basis-10-6-sm">
            <span className="mobile-column-name color7-bold">Ghi chú</span>
            <div className="center-wrapper">
              <p className="text-center color7" title={item.NoteChoVay}>
                {catChuoi(item.NoteChoVay, 50)}
              </p>
            </div>
          </div>
        )}
        {objThietLapHienThiDanhSach.IsAnChucNang != true && (
          <div className="custom-table-cell flex-basis-11 flex-basis-15-6-sm  action-cell">
            <div className="center-wrapper">
              {item.Status !== 2 && (
                <div className="iconTableMorman">
                  {laiho_sualaiho && (
                    <a
                      href={() => false}
                      onClick={this.setModalTraGopShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Sửa"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <img src="/app-assets/images/icon-edit-v2.png" />
                      </PopoversBootrap>
                    </a>
                  )}
                  {laiho_thanhtoan && (
                    <a
                      onClick={this.setDongLaiModalShow(item)}
                      href={() => false}
                    >
                      <PopoversBootrap
                        contentText="Đóng lãi"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="dong-lai-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}

                  {laiho_tattoan && (
                    <a
                      href={() => false}
                      onClick={this.setModalTatToanShow(item)}
                    >
                      <PopoversBootrap
                        contentText="Tất toán"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <span className="tat-toan-button"></span>
                      </PopoversBootrap>
                    </a>
                  )}
                  {item.StatusPaidHo !== 3 && laiho_daoho && (
                    <a
                      onClick={this.setModalDaoHoShow(item)}
                      href={() => false}
                    >
                      <PopoversBootrap
                        contentText="Đảo họ"
                        titleText=""
                        trigger={["hover", "focus"]}
                        placement={"top"}
                      >
                        <img src="/app-assets/images/icon-dao-ho-v2.png" />
                      </PopoversBootrap>
                    </a>
                  )}
                  {/* {isQRThanhToan && (
                  <a
                    className=""
                    onClick={this.setModalQRThanhToanShow(item)}
                    href={() => false}
                  >
                    <PopoversBootrap
                      contentText="QR thanh toán"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <i className="mdi mdi-qrcode"></i>
                    </PopoversBootrap>
                  </a>
                )} */}
                  <Dropdown className="DropNew trangthai-new dropdown-toggle">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                      <img
                        src="/app-assets/images/icon-more.png"
                        alt="Dropdown icon"
                        className="dropdown-icon"
                      />
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      className="dropdown-menu-v2 arrow"
                      style={{ borderRadius: "10px" }}
                    >
                      <div className="block-iconmm   vertical-layout">
                        {laiho_nhantin && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiTinNhan}
                          >
                            <PopoversBootrap
                              contentText="Nhắn tin"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-tin-nhan.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Nhắn tin</span>
                          </a>
                        )}
                        {tragop_thaydoikylai && item.StatusPaidHo === 2 && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalThayDoiKyLaiShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Đổi kỳ lãi"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                src="/app-assets/images/icon-thay-doi-lai-suat-v3.png"
                                style={{
                                  transform: "scale(1.3)",
                                  marginRight: "6px",
                                  marginLeft: "5px",
                                }}
                              />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Đổi kỳ lãi</span>
                          </a>
                        )}
                        {tragop_thaydoilaisuat && item.StatusPaidHo === 2 && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalThayDoiLaiSuatShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Đổi lãi suất"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                src="/app-assets/images/icon-thay-doi-lai-suat-v3.png"
                                style={{
                                  transform: "scale(1.3)",
                                  marginRight: "6px",
                                  marginLeft: "5px",
                                }}
                              />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Đổi lãi suất</span>
                          </a>
                        )}
                        {laiho_guiemail && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showModalGuiEmail}
                          >
                            <PopoversBootrap
                              contentText="Gửi Email"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-gui-mail.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Gửi Email</span>
                          </a>
                        )}
                        {laiho_doitinhtranghopdong && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={this.setModalDoiTinhTrangNoShow(item)}
                          >
                            <PopoversBootrap
                              contentText="Đổi tình trạng nợ"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-doi-tinh-trang-no.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">
                              Đổi tình trạng nợ
                            </span>
                          </a>
                        )}
                        {this.state.isShowGhiChuTraGop === true && (
                          <a
                            className="dropdown-item"
                            onClick={this.setModalGhiChuShow(item)}
                            href={() => false}
                          >
                            <PopoversBootrap
                              contentText="Ghi chú"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img src="/app-assets/images/icon-ghi-chu-tra-gop-v2.png" />
                            </PopoversBootrap>
                            <span class="vertical-align-v2">Ghi chú</span>
                          </a>
                        )}
                        {laiho_xoalaiho && (
                          <a
                            className="dropdown-item"
                            href={() => false}
                            onClick={showXoaHopDong}
                          >
                            <PopoversBootrap
                              contentText="Xoá"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <img
                                style={{ marginLeft: "5px" }}
                                src="/app-assets/images/icon-xoa-v2.png"
                              />
                            </PopoversBootrap>
                            <span
                              class="vertical-align-v2"
                              style={{ color: "#FF5170", marginLeft: "10px" }}
                            >
                              Xóa
                            </span>
                          </a>
                        )}
                        {isQRThanhToan && (
                          <a
                            className="dropdown-item"
                            onClick={this.setModalQRThanhToanShow(item)}
                            href={() => false}
                          >
                            <PopoversBootrap
                              contentText="QR thanh toán"
                              titleText=""
                              trigger={["hover", "focus"]}
                              placement={"top"}
                            >
                              <i
                                className="mdi mdi-qrcode"
                                hidden={isQRThanhToan}
                              ></i>
                            </PopoversBootrap>
                          </a>
                        )}
                      </div>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
              {item.Status === 2 && (
                <div className="iconTableMorman">
                  <a
                    onClick={this.setModalSaoChepShow(item)}
                    href={() => false}
                  >
                    <PopoversBootrap
                      contentText="Sao chép"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <i className="mdi mdi-content-copy"></i>
                    </PopoversBootrap>
                  </a>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    ));
  }

  setModalGhiChuShow = (choVay) => () => {
    // let { showGhiChu } = this.state;
    // if (choVay) this.setState({ showGhiChu: !showGhiChu, choVay });
    // else this.setState({ showGhiChu: !showGhiChu });
    // if (showGhiChu) {
    //   let { dataSearch } = this.state;
    //   dataSearch.pageIndex = 1;
    //   this.setState({ dataSearch });
    //   this.loadTraGop(dataSearch);
    // }
    let { showModalGhiChuChoVay } = this.props;
    if (choVay) this.setState({ choVay });
    showModalGhiChuChoVay();
    if (!choVay) {
      let { dataSearch } = this.state;
      // dataSearch.pageIndex = 1;
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };
  refress = () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadTraGop(dataSearch);
    this.loadTotalTraGop(dataSearch);
  };
  handlePageChange = (pageNumber) => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = pageNumber;
    this.setState({ dataSearch });
    this.loadTraGop(dataSearch);
    this.loadTotalTraGop(dataSearch);
  };
  _onSelectNguonKhachHang = (field) => (event) => {
    let { dataSearch } = this.state;
    dataSearch[field] = event.target.value;
    this.setState({ dataSearch });
  };
  _onSelect = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    this.setState({ dataSearch });
  };
  _onSelectDate = (field) => (value) => {
    let { dataSearch } = this.state;
    dataSearch[field] = value.value;
    dataSearch.dateFrom = "01/01/2001";
    dataSearch.dateTo = "01/01/4001";
    if (value.value === "1") {
      dataSearch.dateFrom = formatDayMonth(new Date());
      dataSearch.dateTo = formatDayMonth(new Date());
    }
    if (value.value === "2") {
      var date2s = startAndEndOfWeek(new Date());
      dataSearch.dateFrom = formatDayMonth(date2s[0]);
      dataSearch.dateTo = formatDayMonth(date2s[1]);
    }
    if (value.value === "3") {
      var date1s = startAndEndOfMonth(new Date());
      dataSearch.dateFrom = formatDayMonth(date1s[0]);
      dataSearch.dateTo = formatDayMonth(date1s[1]);
    }
    if (value.value === "4") {
      var date4s = startAndEndOfYear(new Date());
      dataSearch.dateFrom = formatDayMonth(date4s[0]);
      dataSearch.dateTo = formatDayMonth(date4s[1]);
    }
    // Hôm qua
    if (value.value === "5") {
      dataSearch.dateFrom = GetDateHomQua();
      dataSearch.dateTo = GetDateHomQua();
    }
    this.setState({ dataSearch });
  };
  onChangeData = (field) => (event) => {
    let { dataSearch } = this.state;
    if (field == "customerName") {
      var arr = event.target.value.split("|");
      if (arr.length == 7) {
        dataSearch.pageIndex = 1;
        dataSearch.customerName = arr[0];
        this.loadTraGop(dataSearch);
        this.loadTotalTraGop(dataSearch);
      } else {
        dataSearch[field] = event.target.value;
      }
    } else {
      dataSearch[field] = event.target.value;
    }
    this.setState({ dataSearch });
  };
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      let { dataSearch } = this.state;
      dataSearch.pageIndex = 1;
      dataSearch.customerName = dataSearch.customerName.trim();
      this.setState({ dataSearch });
      this.loadTraGop(dataSearch);
      this.loadTotalTraGop(dataSearch);
    }
  };
  onSearch = () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    dataSearch.customerName = dataSearch.customerName.trim();
    this.setState({ dataSearch });
    this.loadTraGop(dataSearch);
    this.loadTotalTraGop(dataSearch);
  };
  getListData = () => () => {
    let { dataSearch } = this.state;
    dataSearch.pageIndex = 1;
    this.setState({ dataSearch });
    this.loadTraGop(dataSearch);
    this.loadTotalTraGop(dataSearch);
  };
  toggleModalQRThanhToanHD() {
    this.setState({
      isShowModalQRThanhToanHD: !this.state.isShowModalQRThanhToanHD,
    });
  }
  setModalQRThanhToanShow = (hopdong) => () => {
    this.setState({ itemDataQR: hopdong });
    this.toggleModalQRThanhToanHD();
  };

  toggleModalThietLapHienThi() {
    this.setState({
      isShowModalThietLapHienThi: !this.state.isShowModalThietLapHienThi,
    });
  }
  setModalThietLapHienThi = () => () => {
    this.toggleModalThietLapHienThi();
  };

  render() {
    let {
      dataSearch,
      showTKNangCao,
      showChiTietKhachHang,
      showChiTietHopDong,
      showDoiTinhTrangNo,
      choVay,
      showTatToan,
      showDongLai,
      showThayDoiLaiSuat,
      postThayDoiLaiSuatChoVay,
      showInChoVay,
      showXuatExcel3,
      showChiTietSoTienDaTra,
      showChiTietTongSoTienDaTra,
      isCauHinhKhachHangVSNY,
      isCauHinhTaiKhoanIcloud,
      isCauHinhT77,
      sSearchTaiKhoanIcloud,
      listTaiKhoanIcloud,
      objThietLapHienThiDanhSach,
      showThayDoiKyLai,
      configIsThongTinTong,
    } = this.state;

    let {
      user,
      tragop,
      phanquyen,
      inthuchi,
      themmoitragop,
      daoho,
      ghichuchovay,
      getLanDongLaiChoVay,
      getLichSuVayThemChoVay,
    } = this.props;
    let {
      TotalMoney,
      TotalPaid,
      TotalPaidToDateNow,
      TotalQuantity,
      TT_Amercement,
      TT_OtheFeeHangKy,
      TT_OtherFee,
      TT_PhiHoaHongTraGop,
      TT_PhiKho,
      TT_PhiPhatDongLai,
      TT_ValueGoc,
      TT_ValueLai,
      TT_PhiPhatTatToan,
      iTotal,
    } = tragop.objList;
    let { PhanQuyenTraGop } = phanquyen;
    let {
      laiho_inhopdonglaiho,
      laiho_themmoilaiho,
      laiho_xuatexceldanhsachlaiho,
      chonngaygiaodich,
      tragop_thaydoitienlai,
      thuchihopdong_suaphieuthuchi,
      thuchihopdong_xoaphieuthuchi,
      laiho_tattoan,
      laiho_thanhtoan,
      tragop_suatientattoan,
      SuDungPhiPhat_DongLai_TatToan,
      SuDungCongTacVienNhanVien,
      SuDungMaNhanVien,
      SuDungTachNoXau,
      SuDungTatToanSom,
      tragop_thaydoilaisuat,
      tragop_thongtintong,
    } = PhanQuyenTraGop;
    const isShowThongTinTong =
      configIsThongTinTong != 1 ||
      (configIsThongTinTong == 1 && tragop_thongtintong);
    let { inThuChiShow } = inthuchi;
    let { getListTraGopLoading } = tragop;
    let { isShowFormTraGop, ConfigTMTG } = themmoitragop;
    let { isShowFormDaoHo } = daoho;
    let { HoaHongTraGop } = ConfigTMTG;
    let { showGhiChuChoVay } = ghichuchovay;

    const soTienDaTra =
      this.state.TT_Amercement +
      this.state.TT_OtheFeeHangKy +
      this.state.TT_OtherFee +
      this.state.TT_PhiHoaHongTraGop +
      this.state.TT_PhiKho +
      this.state.TT_PhiPhatDongLai +
      this.state.TT_ValueGoc +
      this.state.TT_ValueLai +
      this.state.TT_PhiPhatTatToan;
    return (
      <LayoutV2>
        <div id="form-repeater">
          <div className="sticky-moman-bh2">
            <div className="col-12">
              <div className="laiho-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-tragop-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Trả góp</h1>
                          {/* </div> */}
                          {/* <div className="col-sm-6"></div> */}
                        </div>
                      </div>
                      <div className="hide-table-main show-mobile-main hidden-des-main">
                        {laiho_themmoilaiho && (
                          <div>
                            <button
                              type="button"
                              className="btn btn-border-new"
                              onClick={this.setModalTraGopShow()}
                              style={{ margin: "0px" }}
                            >
                              <img
                                src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                                style={{ paddingBottom: "5px" }}
                              />{" "}
                              Thêm mới
                            </button>
                          </div>
                        )}
                      </div>
                      <div className="bg-right-breacrumb hidden-mobile-main">
                        <div className="btn-group btn-light-v2 ">
                          <ul>
                            <li>
                              {laiho_inhopdonglaiho && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.setInChoVayModalShow()}
                                >
                                  <img src="/app-assets/images/logo-print-v2.png" />
                                </a>
                              )}
                            </li>
                            <li>
                              {laiho_xuatexceldanhsachlaiho && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.xuatExcel()}
                                >
                                  <img src="/app-assets/images/icon-tai-xuong-v2.png" />
                                </a>
                              )}
                            </li>
                            <li>
                              {laiho_xuatexceldanhsachlaiho && (
                                <a
                                  href={() => false}
                                  className="icon-bgnew color-print1"
                                  onClick={this.xuatExcel3()}
                                >
                                  <img src="/app-assets/images/logo-xoa-v2.png" />
                                </a>
                              )}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-3 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <div className="search-new">
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tìm kiếm
                        </label>
                        <input
                          type="text"
                          className="form-control input-sm"
                          placeholder="Tên, sđt khách hàng"
                          onChange={this.onChangeData("customerName")}
                          onKeyDown={this.handleKeyDown}
                          value={dataSearch.customerName}
                        />
                      </div>

                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Trạng Thái
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("status")}
                          options={ChoVayCombo.StatusCombo}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          arrowClassName=""
                          value={dataSearch.status}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Tình trạng
                        </label>
                        <ReactDropdown
                          onChange={this._onSelect("debt")}
                          // options={ChoVayCombo.TinhTrangCombo}
                          options={this.state.listTinhTrangNo}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                          value={dataSearch.debt}
                        />
                      </div>
                      <div className="input-sm-new input-new-18">
                        <label
                          htmlFor="customer-name"
                          className="font-color-default font-bold"
                        >
                          Thời gian
                        </label>
                        <ReactDropdown
                          onChange={this._onSelectDate("ThoiGian")}
                          options={ChoVayCombo.ThoiGianCombo}
                          value={ChoVayCombo.ThoiGianDefault}
                          placeholder="Select an option"
                          controlClassName="form-control input-sm"
                        />
                      </div>
                      {(SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                        <div className="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            {SuDungCongTacVienNhanVien
                              ? "Mã Nhân Viên"
                              : "Nhân Viên"}
                          </label>
                          <input
                            type="text"
                            className="form-control input-sm"
                            placeholder={
                              SuDungCongTacVienNhanVien
                                ? "Mã Nhân Viên"
                                : "Nhân Viên"
                            }
                            onChange={this.onChangeData("manhanvien")}
                            onKeyDown={this.handleKeyDown}
                            value={dataSearch.manhanvien}
                          />
                        </div>
                      )}
                      {isCauHinhTaiKhoanIcloud && (
                        <div class="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            Chọn tài khoản icloud
                          </label>
                          <Autocomplete
                            wrapperProps={{}}
                            wrapperStyle={{
                              position: "relative",
                              width: "100%",
                            }}
                            placeholder="Where is it?"
                            inputProps={{
                              className:
                                "form-control input-sm card-autocomplete",
                            }}
                            menuStyle={{
                              borderRadius: "3px",
                              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                              background: "rgba(255, 255, 255, 0.9)",
                              padding: "2px 0",
                              fontSize: "90%",
                              position: "absolute",
                              overflow: "auto",
                              maxHeight: "150px", // TODO: don't cheat, let it flow to the bottom
                              top: "0 !important",
                              left: "0 !important",
                              zIndex: "1000",
                            }}
                            getItemValue={(item) =>
                              item.TenTaiKhoan + "-" + item.SoDienThoai
                            }
                            renderInput={(props) => (
                              <input
                                {...props}
                                placeholder="Chọn tài khoản icloud" // Thêm placeholder ở đây
                              />
                            )}
                            items={listTaiKhoanIcloud}
                            renderItem={(item, isHighlighted) => {
                              return (
                                <div
                                  className="auto-list"
                                  style={{
                                    background: isHighlighted
                                      ? "lightgray"
                                      : "white",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {item.TenTaiKhoan + "-" + item.SoDienThoai}
                                </div>
                              );
                            }}
                            value={sSearchTaiKhoanIcloud}
                            onSelect={(value, item) => {
                              this.onSelectIcloud(value, item);
                            }}
                            onChange={(event, value) => {
                              this.onChangeTextIcloud(event, value);
                            }}
                          />
                        </div>
                      )}
                      {isCauHinhTaiKhoanIcloud && (
                        <div className="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            Chọn nguồn khách hàng
                          </label>

                          <Autocomplete
                            wrapperProps={{}}
                            wrapperStyle={{
                              position: "relative",
                              width: "100%",
                            }}
                            inputProps={{
                              className:
                                "form-control select-v2 color7 input-sm card-autocomplete",
                            }}
                            menuStyle={{
                              borderRadius: "3px",
                              boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
                              background: "rgba(255, 255, 255, 0.9)",
                              padding: "2px 0",
                              fontSize: "90%",
                              position: "absolute",
                              overflow: "auto",
                              maxHeight: "150px", // TODO: don't cheat, let it flow to the bottom
                              top: "0 !important",
                              left: "0 !important",
                              zIndex: "1000",
                            }}
                            getItemValue={(item) => item.label}
                            renderInput={(props) => (
                              <input
                                {...props}
                                placeholder="Chọn nguồn khách hàng" // Thêm placeholder ở đây
                              />
                            )}
                            items={this.state.lstNguonKhachHangShowSelect}
                            renderItem={(item, isHighlighted) => {
                              return (
                                <div
                                  className="auto-list color7"
                                  style={{
                                    background: isHighlighted
                                      ? "lightgray"
                                      : "white",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {item.label}
                                </div>
                              );
                            }}
                            value={this.state.sSearchNguonKhachHang}
                            onSelect={(value, item) => {
                              this.onSelectNguonKhachHang(value, item);
                            }}
                            onChange={(event, value) => {
                              this.onChangeNguonKhachHang(event, value);
                            }}
                          />
                        </div>
                      )}
                      {SuDungMaNhanVien && (
                        <div className="input-sm-new input-new-18">
                          <label
                            htmlFor="customer-name"
                            className="font-color-default font-bold"
                          >
                            Nhân Viên
                          </label>
                          <ReactDropdown
                            onChange={this._onSelect("manhanvien")}
                            // options={ChoVayCombo.TinhTrangCombo}
                            options={this.state.listNhanVien}
                            placeholder="Chọn nhân viên"
                            controlClassName="form-control input-sm"
                            value={dataSearch.manhanvien}
                          />
                        </div>
                      )}
                      <div className="input-sm-new input-new-18 search-main-new">
                        <button
                          type="submit"
                          className="btn btn-info-new btn-seach-ds"
                          onClick={this.onSearch}
                        >
                          <i className="la la-search"></i>
                          <span> &nbsp; Tìm kiếm</span>
                        </button>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setTKNangCaoModalShow}
                        >
                          <i>
                            <img
                              className="icon-bred-home"
                              src="/app-assets/images/icon-fitter-v2.png"
                              alt=""
                              style={{ scale: "0.9", verticalAlign: "sub" }}
                            />
                          </i>
                        </a>
                        <a
                          href={() => false}
                          className="card-link blue darken-2 text-search-new filter-search"
                          onClick={this.setModalThietLapHienThi()}
                          style={{ marginLeft: 55 }}
                        >
                          <i
                            className="fa fa-cog icon-bred-home"
                            style={{
                              scale: "0.9",
                              verticalAlign: "sub",
                              height: 30,
                            }}
                          ></i>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
                  <div data-repeater-list="car">
                    <div
                      data-repeater-item
                      className="form row bg-search-form form-mobile-search"
                    >
                      <div
                        className="text-right  search-p mb-1 "
                        style={{ width: "100%" }}
                      >
                        <div className="form-search-mobile-new row">
                          <div
                            className="left-search-mobile-new"
                            style={{ width: "85%" }}
                          >
                            <div className="search-mobile-new">
                              <fieldset className="form-group position-relative mb-0">
                                <input
                                  type="text"
                                  className="form-control input-sm"
                                  placeholder="Tên, mã, sđt khách hàng ..."
                                  onChange={this.onChangeData("customerName")}
                                  onKeyDown={this.handleKeyDown}
                                  value={dataSearch.customerName}
                                />
                                <div
                                  className="form-control-position"
                                  onClick={this.onSearch}
                                >
                                  <i className="mdi mdi-magnify"></i>
                                </div>
                              </fieldset>
                            </div>
                          </div>
                          <div className="right-search-mobile-new">
                            <div class="icon-search-mobile">
                              <a
                                href={() => false}
                                className="card-link blue darken-2"
                                onClick={this.setTKNangCaoModalShow}
                              >
                                <i>
                                  <PopoversBootrap
                                    contentText="Tìm kiếm nâng cao"
                                    trigger={["hover", "focus"]}
                                    placement={"top"}
                                  >
                                    <img
                                      className="icon-bred-home"
                                      src="/app-assets/images/icon-fitter-v2.png"
                                      alt=""
                                      style={{
                                        scale: "0.9",
                                        verticalAlign: "sub",
                                        marginTop: "-2px",
                                      }}
                                    />
                                  </PopoversBootrap>
                                </i>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="iconbutton-new hidden-mobile-main show-table-main"></div>
              </div>
            </div>
          </div>
          <div
            className="card border-light mb-3 card-v2"
            style={{
              marginLeft: "15px",
              marginRight: "15px",
              marginTop: "-35px",
            }}
          >
            <div className="card-body card-body-v2">
              <div className="row col-sm-12 col-md-12 themoi-taisanthanhly hidden-mobile-main">
                <div className="col-sm-12 col-md-10">
                  {laiho_themmoilaiho && (
                    <div>
                      <button
                        type="button"
                        className="btn btn-border-new"
                        onClick={this.setModalTraGopShow()}
                        style={{
                          margin: "0px",
                          marginBottom: "2px",
                          borderRadius: "10px !important",
                        }}
                      >
                        <i className="mdi mdi-plus"></i> Thêm mới
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div className="Left808x200 Table-main-new css-table-ds">
                <div className="loading-page1">
                  <div
                    className={
                      "loader loader-default " +
                      (getListTraGopLoading ? "is-active" : "")
                    }
                  ></div>
                </div>
                <div
                  className={
                    this.state.isShowGhiChuTraGop === true
                      ? "table-mobile table-mobileNew table-mobile-hover"
                      : "table-mobile  table-mobile-hover"
                  }
                  style={
                    isCauHinhTaiKhoanIcloud ||
                    SuDungMaNhanVien ||
                    SuDungCongTacVienNhanVien
                      ? { overflowX: "auto", minHeight: "440px" }
                      : { minHeight: "440px" }
                  }
                >
                  <div
                    className={
                      this.state.isShowGhiChuTraGop === true
                        ? "custom-table-wrapper custom-table-wrapperNew"
                        : "custom-table-wrapper"
                    }
                  >
                    <div className="table-headers">
                      {objThietLapHienThiDanhSach.IsAnSTT != true && (
                        <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                          <p className="text-center">
                            STT
                            <br />{" "}
                            {isShowThongTinTong && (
                              <span className="color-do-bold">[{iTotal}]</span>
                            )}
                          </p>
                        </div>
                      )}
                      {isCauHinhKhachHangVSNY == false && (
                        <>
                          {objThietLapHienThiDanhSach.IsAnMaHD != true && (
                            <div className="custom-table-header flex-basis-9 flex-basis-15-6-sm">
                              <p>Mã hợp đồng</p>
                            </div>
                          )}
                          {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
                            (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                              <div className="custom-table-header flex-basis-6 flex-basis-6-sm">
                                <p>
                                  {SuDungCongTacVienNhanVien
                                    ? "Mã nhân viên"
                                    : "Nhân viên"}
                                </p>
                              </div>
                            )}
                          {objThietLapHienThiDanhSach.IsAnTenKH != true && (
                            <div
                              className={`custom-table-header ${
                                SuDungCongTacVienNhanVien || SuDungMaNhanVien
                                  ? "flex-basis-12 flex-basis-11-8-sm"
                                  : "flex-basis-11 flex-basis-11-8-sm"
                              }`}
                            >
                              <p>Tên khách hàng</p>
                            </div>
                          )}
                        </>
                      )}
                      {isCauHinhKhachHangVSNY == true && (
                        <>
                          {objThietLapHienThiDanhSach.IsAnTenKH != true && (
                            <div
                              className={`custom-table-header ${
                                SuDungCongTacVienNhanVien || SuDungMaNhanVien
                                  ? "flex-basis-12 flex-basis-11-8-sm"
                                  : "flex-basis-11 flex-basis-11-8-sm"
                              }`}
                            >
                              <p>Tên khách hàng</p>
                            </div>
                          )}
                          {objThietLapHienThiDanhSach.IsAnMaHD != true && (
                            <div className="custom-table-header flex-basis-9 flex-basis-15-6-sm">
                              <p>Mã hợp đồng</p>
                            </div>
                          )}
                          {objThietLapHienThiDanhSach.IsAnNhanVien != true &&
                            (SuDungCongTacVienNhanVien || SuDungMaNhanVien) && (
                              <div className="custom-table-header flex-basis-6 flex-basis-6-sm">
                                <p>
                                  {SuDungCongTacVienNhanVien
                                    ? "Mã nhân viên"
                                    : "Nhân viên"}
                                </p>
                              </div>
                            )}
                        </>
                      )}
                      {objThietLapHienThiDanhSach.IsAnTSTheChap != true &&
                        isCauHinhTaiKhoanIcloud == false && (
                          <div className="custom-table-header flex-basis-8 flex-basis-7-sm">
                            <p className="text-center">
                              {isCauHinhT77 ? "Tài sản" : "TS thế chấp"}
                            </p>
                          </div>
                        )}
                      {isCauHinhTaiKhoanIcloud == true && (
                        <div className="custom-table-header flex-basis-8 flex-basis-6-sm">
                          <p className="text-center">Nguồn khách hàng</p>
                        </div>
                      )}
                      {isCauHinhTaiKhoanIcloud == true && (
                        <div className="custom-table-header flex-basis-16 flex-basis-12-sm">
                          <p className="text-center">Icloud</p>
                        </div>
                      )}
                      {this.state.isCauHinhKhachHangBinhAn == true && (
                        <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                          <p className="text-right">
                            Tiền đưa khách
                            <br />{" "}
                            {this.state.isLoadingTongTien === true ? (
                              <div className="dot-loading-tq">
                                <div class="dots-5"></div>
                              </div>
                            ) : (
                              <>
                                <span
                                  className="color-do-bold"
                                  title={formatNumber(this.state.TotalMoney)}
                                >
                                  {formatMoney(this.state.TotalMoney)}
                                </span>
                              </>
                            )}
                          </p>
                        </div>
                      )}
                      {objThietLapHienThiDanhSach.IsAnSoTienVay != true &&
                        this.state.isCauHinhKhachHangBinhAn == false && (
                          <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                            <p className="text-right">
                              Số tiền vay
                              <br />{" "}
                              {this.state.isLoadingTongTien === true ? (
                                <div className="dot-loading-tq">
                                  <div class="dots-5"></div>
                                </div>
                              ) : (
                                <>
                                  {" "}
                                  {isShowThongTinTong && (
                                    <span
                                      className="color-do-bold"
                                      title={formatNumber(
                                        this.state.TotalMoney,
                                      )}
                                    >
                                      {formatCurrency(this.state.TotalMoney)}
                                    </span>
                                  )}
                                </>
                              )}
                            </p>
                          </div>
                        )}
                      {objThietLapHienThiDanhSach.IsAnSoTienDaTra != true && (
                        <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                          <p className="text-right">
                            Số tiền đã trả
                            <br />{" "}
                            {this.state.isLoadingTongTien === true ? (
                              <div className="dot-loading-tq">
                                <div class="dots-5"></div>
                              </div>
                            ) : (
                              <>
                                {isShowThongTinTong && (
                                  <span
                                    className="home-new-blue"
                                    title={formatNumber(
                                      this.state.TT_Amercement +
                                        this.state.TT_OtheFeeHangKy +
                                        this.state.TT_OtherFee +
                                        this.state.TT_PhiHoaHongTraGop +
                                        this.state.TT_PhiKho +
                                        this.state.TT_PhiPhatDongLai +
                                        this.state.TT_ValueGoc +
                                        this.state.TT_ValueLai +
                                        this.state.TT_PhiPhatTatToan,
                                    )}
                                  >
                                    <a
                                      id=""
                                      href={() => false}
                                      onClick={this.setModalChiTietTongTienDaTraShow()}
                                    >
                                      {formatCurrency(
                                        this.state.TT_Amercement +
                                          this.state.TT_OtheFeeHangKy +
                                          this.state.TT_OtherFee +
                                          this.state.TT_PhiHoaHongTraGop +
                                          this.state.TT_PhiKho +
                                          this.state.TT_PhiPhatDongLai +
                                          this.state.TT_ValueGoc +
                                          this.state.TT_ValueLai +
                                          this.state.TT_PhiPhatTatToan,
                                      )}
                                    </a>
                                    {/* {formatNumber(TotalPaid)} */}
                                  </span>
                                )}
                              </>
                            )}{" "}
                          </p>
                        </div>
                      )}
                      {objThietLapHienThiDanhSach.IsAnTienVayConLai != true && (
                        <div className="custom-table-header flex-basis-11 flex-basis-13-sm">
                          <p className="text-right">
                            Còn phải đóng <br />{" "}
                            {this.state.isLoadingTongTien === true ? (
                              <div className="dot-loading-tq">
                                <div class="dots-5"></div>
                              </div>
                            ) : (
                              isShowThongTinTong && (
                                <span
                                  className="color-cam-bold"
                                  title={formatNumber(
                                    this.state.TotalPaidToDateNow,
                                  )}
                                >
                                  {formatCurrency(
                                    this.state.TotalPaidToDateNow,
                                  )}
                                </span>
                              )
                            )}
                          </p>
                        </div>
                      )}{" "}
                      {objThietLapHienThiDanhSach.IsAnTrangThai != true && (
                        <div className="custom-table-header flex-basis-6 flex-basis-6-sm">
                          <p className="tab-header text-center">Trạng thái</p>
                        </div>
                      )}
                      {this.state.isShowGhiChuTraGop === true && (
                        <div className="custom-table-header flex-basis-10  flex-basis-10-6-sm">
                          <p className="tab-header text-center">Ghi chú</p>
                        </div>
                      )}
                      {objThietLapHienThiDanhSach.IsAnChucNang != true && (
                        <div className="custom-table-header flex-basis-11 flex-basis-15-6-sm action-cell">
                          <p className="tab-header">Chức năng</p>
                        </div>
                      )}
                    </div>

                    <div className="custom-table-body">
                      {this.renderTableRows()}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            className="card border-light mb-3 card-v2"
            style={{
              marginLeft: "15px",
              marginRight: "15px",
              marginTop: "-25px",
            }}
          >
            <div className="card-body card-body-v2">
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <span className="color7">
                    {iTotal === 0 ? (
                      "Hiển thị 0 - 0 / Tổng số 0"
                    ) : (
                      <>
                        Hiển thị{" "}
                        {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                        {Math.min(
                          dataSearch.pageIndex * dataSearch.pageSize,
                          iTotal,
                        )}{" "}
                        / Tổng số {iTotal}
                      </>
                    )}
                  </span>
                </div>
                <div className="col-sm-12 col-md-6">
                  <div
                    className={
                      "paniation-new paniation-new1 d-flex justify-content-center " +
                      (iTotal === 0 ? "hidden" : "")
                    }
                    style={{ float: "right" }}
                  >
                    <nav aria-label="Page navigation">
                      <Pagination
                        activePage={dataSearch.pageIndex}
                        itemsCountPerPage={dataSearch.pageSize}
                        totalItemsCount={iTotal}
                        pageRangeDisplayed={5}
                        onChange={this.handlePageChange}
                        itemClass="page-item border-none"
                        linkClass="page-link border-none"
                        activeClass="active"
                      />
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isShowFormTraGop && (
          <ThemMoiTraGop
            show={isShowFormTraGop}
            onHide={this.setModalTraGopShow(null)}
            inPhieuThu={this.setInThuChiModalShow}
            inHopDong={this.setInChoVayModalShowTM}
            setIsTraGopReturn={this.setIsTraGopReturn}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungCongTacVienNhanVien={SuDungCongTacVienNhanVien}
            SuDungMaNhanVien={SuDungMaNhanVien}
            SuDungTatToanSom={SuDungTatToanSom}
          ></ThemMoiTraGop>
        )}

        {isShowFormDaoHo && (
          <DaoHoContainer
            onHide={this.setModalDaoHoShow()}
            onRefes={this.setLoadingToTalDaoHo()}
          ></DaoHoContainer>
        )}

        {showChiTietKhachHang && (
          <CustomerDetail
            onHide={this.setModalChiTietKhachHangShow(choVay)}
            show={showChiTietKhachHang && !showChiTietHopDong}
            showChiTietHopDong={this.setModalChiTietHopDongShow}
            data={choVay}
          ></CustomerDetail>
        )}

        {showDongLai && (
          <DongLaiContainer
            show={
              showDongLai &&
              !inThuChiShow &&
              !this.state.isShowSuaKyLai &&
              !this.state.isShowInDanhSachDongLai
            }
            onHide={this.setDongLaiModalShow(choVay)}
            onShowPhieuThu={this.setInThuChiModalShow}
            onShowSuaKyLai={this.setSuaKyLaiModalShow}
            onShowInDanhSachDongLai={this.setInDanhSachDongLaiShow}
            data={choVay}
            thaydoitienlai={tragop_thaydoitienlai}
            chonngaygiaodich={chonngaygiaodich}
            xoaphieuthuchi={thuchihopdong_xoaphieuthuchi}
            showPhiPhat={HoaHongTraGop === 1}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            isCauHinhKhachHangVSNY={isCauHinhKhachHangVSNY}
            buttonLeft={
              <ButtonChuyenForm
                // showDongLai={this.setDongLaiModalShow(choVay)}
                showTatToan={this.setModalTatToanShow(choVay)}
                quyenTatToan={laiho_tattoan}
              ></ButtonChuyenForm>
            }
          ></DongLaiContainer>
        )}
        {showThayDoiLaiSuat && (
          <ThayDoiLaiSuatContainer
            show={showThayDoiLaiSuat && !inThuChiShow}
            data={choVay}
            quanlychovay={this.state.quanlychovay}
            postThayDoiLaiSuatChoVay={postThayDoiLaiSuatChoVay}
            onHide={this.setModalThayDoiLaiSuatShow(choVay)}
            chonngaygiaodich={chonngaygiaodich}
            quyenSuaTienTatToan={tragop_suatientattoan}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungTatToanSom={SuDungTatToanSom}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laiho_thanhtoan}
              ></ButtonChuyenForm>
            }
          ></ThayDoiLaiSuatContainer>
        )}
        {showThayDoiKyLai && (
          <ThayDoiKyLaiTraGopContainer
            show={showThayDoiKyLai && !inThuChiShow}
            data={choVay}
            ConfigTMTG={ConfigTMTG}
            // getLanDongLaiChoVay={getLanDongLaiChoVay}
            postThayDoiLaiSuatChoVay={postThayDoiLaiSuatChoVay}
            // getLichSuVayThemChoVay={getLichSuVayThemChoVay}
            // quanlychovay={this.state.quanlychovay}
            // quanlythuchi={quanlythuchi}
            onHide={this.setModalThayDoiKyLaiShow(choVay)}
            // deleteVayThem={deleteVayThemChoVay}
            chonngaygiaodich={chonngaygiaodich}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laiho_thanhtoan}
              ></ButtonChuyenForm>
            }
            phanquyen={phanquyen}
          ></ThayDoiKyLaiTraGopContainer>
        )}
        {showTatToan && (
          <TatToanContainer
            show={showTatToan && !inThuChiShow}
            data={choVay}
            onHide={this.setModalTatToanShow(choVay)}
            chonngaygiaodich={chonngaygiaodich}
            quyenSuaTienTatToan={tragop_suatientattoan}
            SuDungPhiPhat_DongLai_TatToan={SuDungPhiPhat_DongLai_TatToan}
            SuDungTatToanSom={SuDungTatToanSom}
            buttonLeft={
              <ButtonChuyenForm
                showDongLai={this.setDongLaiModalShow(choVay)}
                quyenDongLai={laiho_thanhtoan}
              ></ButtonChuyenForm>
            }
          ></TatToanContainer>
        )}
        {showInChoVay && (
          <InChoVay
            data={choVay}
            show={showInChoVay}
            onHide={this.setInChoVayModalShow()}
          ></InChoVay>
        )}
        {this.state.isShowSuaKyLai && (
          <ModalSuaKyLai
            show={this.state.isShowSuaKyLai}
            onHide={this.setSuaKyLaiModalShow()}
            data={this.state.dataSuaKyLai}
            dataTotal={this.state.dataTotalDongLai}
            getLanDongLaiChoVay={this.props.getLanDongLaiChoVay}
          />
        )}
        {this.state.isShowInDanhSachDongLai && (
          <ModalInDanhSachDongLai
            show={this.state.isShowInDanhSachDongLai}
            onHide={this.setInDanhSachDongLaiShow()}
            data={this.state.dataInDanhSachDongLai}
          />
        )}

        {inThuChiShow && (
          <InThuChiContainer
            show={inThuChiShow}
            onHide={this.setInThuChiModalShow()}
          ></InThuChiContainer>
        )}
        {showChiTietHopDong && (
          <ChiTietHopDongContainer
            show={showChiTietHopDong}
            onHide={this.setModalChiTietHopDongShow(choVay)}
            setModalTaiSan={this.setModalTaiSan}
            data={choVay}
          ></ChiTietHopDongContainer>
        )}
        {showDoiTinhTrangNo && (
          <DoiTinhTrangNoContainer
            show={showDoiTinhTrangNo}
            onHide={this.setModalDoiTinhTrangNoShow(choVay)}
            data={choVay}
          ></DoiTinhTrangNoContainer>
        )}

        <XoaHopDongContainer
          data={choVay}
          getList={this.getListData()}
        ></XoaHopDongContainer>

        <GuiEmailContainer data={choVay}></GuiEmailContainer>
        <TinNhanContainer data={choVay}></TinNhanContainer>
        <SearchChoVay
          data={dataSearch}
          show={showTKNangCao}
          onHide={this.setTKNangCaoModalShow}
          userCombo={user.combo}
          trangs={"TraGop"}
          type={2}
          listTinhTrangNo={this.state.listTinhTrangNo}
        ></SearchChoVay>
        {showXuatExcel3 && (
          <XuatExcelTraGop
            dataSearch={dataSearch}
            show={showXuatExcel3}
            onHide={this.hideXuatExcel()}
          ></XuatExcelTraGop>
        )}

        {showChiTietSoTienDaTra && (
          <ChiTietSoTienDaTraContainer
            show={showChiTietSoTienDaTra}
            onHide={this.setModalChiTietTienDaTraShow(choVay)}
            data={choVay}
          ></ChiTietSoTienDaTraContainer>
        )}
        {showChiTietTongSoTienDaTra && (
          <ChiTietTongSoTienDaTraContainer
            show={showChiTietTongSoTienDaTra}
            onHide={this.setModalChiTietTongTienDaTraShow()}
            TT_Amercement={this.state.TT_Amercement}
            TT_OtheFeeHangKy={this.state.TT_OtheFeeHangKy}
            TT_OtherFee={this.state.TT_OtherFee}
            TT_PhiHoaHongTraGop={this.state.TT_PhiHoaHongTraGop}
            TT_PhiKho={this.state.TT_PhiKho}
            TT_PhiPhatDongLai={this.state.TT_PhiPhatDongLai}
            TT_ValueGoc={this.state.TT_ValueGoc}
            TT_ValueLai={this.state.TT_ValueLai}
            TT_PhiPhatTatToan={this.state.TT_PhiPhatTatToan}
          ></ChiTietTongSoTienDaTraContainer>
        )}

        {showGhiChuChoVay && (
          <GhiChuTraGopContainer
            show={showGhiChuChoVay}
            onHide={this.setModalGhiChuShow(null)}
            data={choVay}
            refress={this.refress}
          ></GhiChuTraGopContainer>
        )}
        {this.state.isShowModalQRThanhToanHD && (
          <ModelQRThanhToanHD
            show={this.state.isShowModalQRThanhToanHD}
            onHide={this.toggleModalQRThanhToanHD.bind(this)}
            hopdong={this.state.itemDataQR}
          />
        )}
        {this.state.isShowModalThietLapHienThi && (
          <ModelThietLapHienThi
            show={this.state.isShowModalThietLapHienThi}
            onHide={this.toggleModalThietLapHienThi.bind(this)}
            data={this.state.objThietLapHienThiDanhSach}
            SuDungCongTacVienNhanVien={SuDungCongTacVienNhanVien}
            SuDungMaNhanVien={SuDungMaNhanVien}
            getThietLapHienThi={this.getThietLapHienThi.bind(this)}
          />
        )}
      </LayoutV2>
    );
  }
}

TraGop.propTypes = {
  getList: PropTypes.func,
};

export default TraGop;
